import { getCleanProductHandle } from 'utils/helpers';
import WithoutSSR from '../without-ssr/without-ssr';

export type BvReviewsProps = {
  slug?: string;
};

export const BvReviews = ({ slug }: BvReviewsProps) => {
  if (!slug) {
    return null;
  }

  return (
    <WithoutSSR>
      <div
        data-bv-show="reviews"
        data-bv-productid={getCleanProductHandle(slug)}
      />
    </WithoutSSR>
  );
};
